import UAParser from "ua-parser-js";
import { api } from "./index";
import { articleAPI } from "./modules/article";
import { formAPI } from "./modules/form";

export let $api = {
  /**
   * 获取 globalUserId
   * @returns {*}
   */
  onAnonymousGetId() {
    return api.request("/anonymous/getId", {
      clientType: UAParser().os.name,
      clientVersion: UAParser().browser.version,
      clientBrand: UAParser().browser.name,
      clientIP: "",
    });
  },

  ...articleAPI,
  ...formAPI,
};

export let API = {
  install(Vue) {
    Vue.prototype.$api = $api;
  },
};
